// extracted by mini-css-extract-plugin
export default {"mCard":"oD-z","image":"pD-z","imageNoBackground":"qD-z","imageHasCategory":"rD-z","fullWidth":"sD-z"};